import { render, staticRenderFns } from "./PopupContentsView.vue?vue&type=template&id=76ba63df&scoped=true"
import script from "./PopupContentsView.vue?vue&type=script&lang=js"
export * from "./PopupContentsView.vue?vue&type=script&lang=js"
import style0 from "./PopupContentsView.vue?vue&type=style&index=0&id=76ba63df&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76ba63df",
  null
  
)

export default component.exports